import React from 'react';

import { Checkbox, Form, Header } from 'semantic-ui-react';

class FormbuilderGroupDivider extends React.Component {

    render() {
        const { checked, identifier, inputLabel, onChange, label } = this.props;

        return (
            <React.Fragment key={identifier}>
                <Header as="h5" className="page-view-heading">
                    {label}
                </Header>
                <Form.Field>
                    <Checkbox label={inputLabel}
                        checked={checked}
                        onChange={onChange} />
                </Form.Field>
            </React.Fragment>
        );
    }
}

export default FormbuilderGroupDivider;